module.exports = __webpack_public_path__ + "media/images/lb/641-b3790941d47453ca22ce0e9823114856.svg";